import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectRowByRowIndex, selectRow } from '@client-shared/ui-agGrid';

import { modalDataSelector } from '../../shared/modals/modals.selectors';


import {
  hideRemoveScenarioModal,
  updateColumnState,
} from './store/actions';

import {
  canCreatePublicScenarioSelector,
  scenarioListColumnStateSelector,
} from './store/selectors';

import ScenariosGrid from './scenariosGrid.component';
import DeleteScenarioModalComponent from './deleteScenarioModal.component';

import { ModalNames } from './constants';
import { ScenarioPropType, ScenarioListColumnState } from '../shared/propTypes';
import { useScenariosAllowedPeriods, useScenariosList } from '../../shared/queries/scenarios';
import { useDeleteScenario } from '../../shared/mutations/scenarios';


const ScenariosPage = ({
  selectRow,
  selectRowByRowIndex,
  canCreatePublicScenario,
  hideRemoveScenarioModal,
  deleteModalData,
  scenarioListColumnState,
  updateColumnState,
}) => {
  const { data: allowedPeriods, isLoading: isLoadingAllowedPeriods } = useScenariosAllowedPeriods();
  const { data: scenarios, isLoading: isLoadingScenarios } = useScenariosList();
  const { mutate: deleteScenario, isLoading: isDeleting } = useDeleteScenario(() => {
    const rowIndex = deleteModalData.data && deleteModalData.data.rowIndex;
    selectRowByRowIndex(rowIndex ? rowIndex - 1 : 0);
    hideRemoveScenarioModal();
  });

  const periodsOptions = useMemo(() => allowedPeriods.map(({ periodName }) => ({
    label: periodName,
    value: periodName,
  })), [allowedPeriods]);

  const isLoading = isLoadingScenarios || isLoadingAllowedPeriods;

  return (
    <div className="scenarios-page">
      <div className="page">
        <div className="container-fluid">
          <div className="row no-gutters page-content-container">
            <div className="col">
              <div className="d-flex flex-row justify-content-between">
                <h5>Scenarios</h5>
              </div>
            </div>
          </div>
          <ScenariosGrid
            scenarios={scenarios}
            periods={periodsOptions}
            selectRow={selectRow}
            selectRowByRowIndex={selectRowByRowIndex}
            canCreatePublicScenario={canCreatePublicScenario}
            isLoading={isLoading}
            isDeleting={isDeleting}
            scenarioListColumnState={scenarioListColumnState}
            updateColumnState={updateColumnState}
          />
        </div>
        <DeleteScenarioModalComponent
          entityToRemove={deleteModalData.data && deleteModalData.data.entity}
          removeEntity={deleteScenario}
          hideModal={hideRemoveScenarioModal}
          rowIndex={deleteModalData.data && deleteModalData.data.rowIndex}
          isRemovingInProgress={isDeleting}
          isVisible={deleteModalData.show}
        />
      </div>
    </div>
  );
};


ScenariosPage.propTypes = {
  isDeleting: PropTypes.bool,
  selectRow: PropTypes.func,
  selectRowByRowIndex: PropTypes.func,
  canCreatePublicScenario: PropTypes.bool,
  hideRemoveScenarioModal: PropTypes.func,
  removeScenario: PropTypes.func,
  deleteModalData: PropTypes.shape({
    data: PropTypes.shape({
      rowIndex: PropTypes.number,
      entity: ScenarioPropType,
    }),
    show: PropTypes.bool,
  }),
  scenarioListColumnState: ScenarioListColumnState,
  updateColumnState: PropTypes.func,
};

const mapStateToProps = state => ({
  deleteModalData: modalDataSelector(state, ModalNames.Delete),
  canCreatePublicScenario: canCreatePublicScenarioSelector(state),
  scenarioListColumnState: scenarioListColumnStateSelector(state),
});

export default connect(mapStateToProps, {
  selectRow,
  selectRowByRowIndex,
  hideRemoveScenarioModal,
  updateColumnState,
})(ScenariosPage);
